import { retrieveUsers } from './userActions'
import { retrievePromoCodes } from './promoCodesActions'

export const setDefaultUserData = () => dispatch => {
	// dispatch(retrieveUsers({ page: 1 }))
}